import React from 'react';
import { useTranslation } from 'react-i18next';

const CookiesPolicy = () => {

    // internationalization
    const { t, i18n } = useTranslation();

    return (
        <div style={{ margin: '0 auto', minHeight: '60vh', lineHeight: '1.6' }}>
            <div style={{ height: '8vh', width: '100%', backgroundColor: '#3C4856' }} />
            <div style={{ maxWidth: '60vw', margin: '0 auto', paddingBottom: '10vh'}}>

                <h1 style={{ marginBottom: '24px' }}>{t("cookies-policy.title")}</h1>

                <p>{t("cookies-policy.intro")}</p>

                <h2 style={{ marginTop: '32px', marginBottom: '16px' }}>{t("cookies-policy.section-1.title")}</h2>
                <p>
                    {t("cookies-policy.section-1.text-1")}<br />
                    {t("cookies-policy.section-1.company")}<br />
                    {t("cookies-policy.section-1.address-1")}<br />
                    {t("cookies-policy.section-1.address-2")}<br />
                    {t("cookies-policy.section-1.tel")}<br />
                    {t("cookies-policy.section-1.email")}
                </p>

                <h2 style={{ marginTop: '32px', marginBottom: '16px' }}>{t("cookies-policy.section-2.title")}</h2>
                <p>{t("cookies-policy.section-2.text")}</p>

                <h2 style={{ marginTop: '32px', marginBottom: '16px' }}>{t("cookies-policy.section-3.title")}</h2>
                <p>{t("cookies-policy.section-3.intro")}</p>
                <ul style={{ paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '8px' }}>
                        <strong>{t("cookies-policy.section-3.necessary.title")}</strong>
                        {t("cookies-policy.section-3.necessary.text-1")}
                        <code>habp_cookie_consent</code>
                        {t("cookies-policy.section-3.necessary.text-2")}
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                        <strong>{t("cookies-policy.section-3.analytics.title")}</strong>
                        {t("cookies-policy.section-3.analytics.text-1")}
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                            {t("cookies-policy.section-3.analytics.link")}
                        </a>.
                    </li>
                </ul>

                <h2 style={{ marginTop: '32px', marginBottom: '16px' }}>{t("cookies-policy.section-4.title")}</h2>
                <p>
                    {t("cookies-policy.section-4.text")}
                </p>

                <p style={{ marginTop: '24px', fontSize: '14px', color: '#666' }}>
                    {t("cookies-policy.last-updated")} 03.11.2026
                </p>
            </div>
        </div>
    );
};

export default CookiesPolicy;
